export const TAG_LIST_CLEAR_STORE = "TAG_LIST_CLEAR_STORE";

export const TAG_LIST_SUMMURY_LOAD_START = "TAG_LIST_SUMMURY_LOAD_START";
export const TAG_LIST_SUMMURY_LOAD_SUCCESS = "TAG_LIST_SUMMURY_LOAD_SUCCESS";
export const TAG_LIST_SUMMURY_LOAD_FAIL = "TAG_LIST_SUMMURY_LOAD_FAIL";

export const TAG_LIST_LOAD_START = "TAG_LIST_LOAD_START";
export const TAG_LIST_LOAD_SUCCESS = "TAG_LIST_LOAD_SUCCESS";
export const TAG_LIST_LOAD_FAIL = "TAG_LIST_LOAD_FAIL";

export const TAG_LIST_REMOVE_START = "TAG_LIST_REMOVE_START";
export const TAG_LIST_REMOVE_SUCCESS = "TAG_LIST_REMOVE_SUCCESS";
export const TAG_LIST_REMOVE_FAIL = "TAG_LIST_REMOVE_FAIL";
